@import '^scss-config';

.wrapper {
  @include desktop {
    padding: 1rem;
  }

  .skeletonBase {
    width: 100%;
    height: 34rem;

    color: var(--theme-color-grey-20);
  }
}
